import debounce from "lodash/debounce";
import { useCallback, useEffect, useMemo } from "react";
import { setLienDirectorySearchTerm } from "reducers/main";
import type { RootState } from "services/store";
import { useDispatch, useSelector } from "utils/redux";

/**
 * custom hook for lien directory search operations
 */
export const useLienDirectorySearch = () => {
  const dispatch = useDispatch();

  const lienDirectorySearchTerm = useSelector(
    (state: RootState) => state.main.lienDirectorySearchTerm,
  );

  const setSearchTerm = useCallback(
    (value: string) => {
      dispatch(setLienDirectorySearchTerm(value?.toLowerCase()));
    },
    [dispatch],
  );

  const debouncedSetSearchTerm = useMemo(
    () => debounce(setSearchTerm, 300),
    [setSearchTerm],
  );

  useEffect(() => {
    return () => {
      debouncedSetSearchTerm.cancel();
    };
  }, [debouncedSetSearchTerm]);

  return {
    lienDirectorySearchTerm,
    setSearchTerm,
    debouncedSetSearchTerm,
  };
};
